import React, { useState, useEffect, useRef } from "react";
import { Box } from "@mui/material";
import Marquee from "react-fast-marquee";
import { backendHosts } from "../../ui-utils/apiConfig"

export default function TickerTape() {
  const [stocks, setStocks] = useState([]);
  const [flashMap, setFlashMap] = useState({});
  const stocksRef = useRef(stocks);

  // Keep a ref of stocks to avoid stale state in SSE updates
  useEffect(() => {
    stocksRef.current = stocks;
  }, [stocks]);

  // SSE connection
  useEffect(() => {
    const evtSource = new EventSource(
      `${backendHosts.ADMIN}/api/market-data/events`
    );

    evtSource.onmessage = (event) => {
      try {
        const rawStocks = JSON.parse(event.data);
        const mappedStocks = rawStocks.map((item) => ({
          tickerSymbol: item.instrument_symbols,
          lastPrice: item.lasttradedprice,
          priceChange: item.lasttradedprice - item.close,
          percentChange: item.percentchange,
        }));

        // Detect changes and trigger flash
        const newFlashMap = {};
        mappedStocks.forEach((stock) => {
          const oldStock = stocksRef.current.find(
            (s) => s.tickerSymbol === stock.tickerSymbol
          );
          if (oldStock) {
            if (stock.lastPrice > oldStock.lastPrice) {
              newFlashMap[stock.tickerSymbol] = "up";
            } else if (stock.lastPrice < oldStock.lastPrice) {
              newFlashMap[stock.tickerSymbol] = "down";
            }
          }
        });

        if (Object.keys(newFlashMap).length > 0) {
          setFlashMap(newFlashMap);
          // Remove flash after 500ms
          setTimeout(() => setFlashMap({}), 500);
        }

        setStocks(mappedStocks);
      } catch (err) {
        console.error("Error parsing SSE data:", err);
      }
    };

    evtSource.onerror = (err) => {
      console.error("SSE connection error:", err);
    };

    return () => evtSource.close();
  }, []);

  return (
    <>
      {stocks?.length === 0 ? null : (
        <Box
          sx={{
            width: "100%",
            overflow: "hidden",
            backgroundColor: "#000",
            position: "relative",
          }}
        >
          <Box
            sx={{
              width: "100%",
              backgroundColor: "#000",
              color: "#fff",
              height: 30,
              display: "flex",
              alignItems: "center",
            }}
          >
            <Marquee pauseOnHover gradient={false} speed={50}>
              {stocks.map((stock, index) => {
                const flash = flashMap[stock.tickerSymbol];

                const priceColor =
                  flash === "up"
                    ? "#32CD32"
                    : flash === "down"
                      ? "#FF0000"
                    : "#fff"; // normal color white

                const changeColor =
                  flash === "up"
                    ? "#32CD32"
                    : flash === "down"
                      ? "#FF0000"
                    : stock.priceChange >= 0
                        ? "#32CD32"
                        : "#FF0000";

                return (
                  <Box
                    key={index}
                    sx={{
                      display: "inline-block",
                      minWidth: 180,
                      marginRight: 4,
                      whiteSpace: "nowrap",
                      fontFamily: "Inter500",
                      cursor: "pointer",
                      fontSize: "calc(14px + var(--font-delta))",
                    }}
                  >
                    <span
                      style={{
                        // transition: "color 0.3s ease",
                        //  paddingRight:'5px'
                      }}
                    >
                      {stock.tickerSymbol}
                      {"  "}
                    </span>
                    <span
                      style={{
                        // transition: "color 0.3s ease",
                        color: priceColor,
                        fontVariantNumeric: "tabular-nums", // ✅ Tabular numbers
                      }}
                    >
                      {stock.lastPrice?.toFixed(2)}{" "}
                    </span>
                    <span
                      style={{
                        // transition: "color 0.3s ease",
                        color: changeColor,
                        fontVariantNumeric: "tabular-nums", // ✅ Tabular numbers
                      }}
                    >
                      {stock.priceChange >= 0 ? "▲" : "▼"}{" "}
                      {Math.abs(stock.priceChange).toFixed(2)} (
                      {Math.abs(stock.percentChange).toFixed(2)}%)
                    </span>
                  </Box>
                );
              })}
            </Marquee>
          </Box>
        </Box>
      )}
    </>
  );
}
